import fp from "lodash/fp";

import { ExecutiveBusinessReviewNameFields } from "globalConstants";
import { deleteEmptyValues } from "mappers";

export const getMappedBusinessReviewForm = formValues => {
	const { businessMessage } = ExecutiveBusinessReviewNameFields;

	return fp.flow(formValues => {
		const mappedValues = {
			business_review_message: formValues?.[businessMessage] || null,
		};

		return mappedValues;
	}, fp.tap(deleteEmptyValues))(formValues);
};
